import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService extends BaseService {
  private localizationServiceURL = 'Localization/';

  constructor(private http: HttpClient) {
    super(environment.registrationApiBaseUrl);
  }
  public getDefaultCultureCodeByClientCountry(clientCountryId: number, providedCultureCode?: string): Observable<string> {
    let url = `${this.serviceUrl}${this.localizationServiceURL}GetDefaultCultureCodeByClientCountry?clientCountryId=${clientCountryId}`;
    if (providedCultureCode) {
      url += `&providedCultureCode=${providedCultureCode}`;
    }
    return this.http.get(url, { responseType: 'text' }).pipe(
      catchError(this.HandleServiceError)
    );
  }

  public getDefaultCultureCodeByClientCountryV2(clientCountryId: number): Observable<string> {
    const url = `${this.serviceUrl}${this.localizationServiceURL}DefaultCultureCodeByClientCountry?clientCountryId=${clientCountryId}`;
    return this.http.get(url, { responseType: 'text' }).pipe(
      catchError(this.HandleServiceError)
    );
  }
}